import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type AlertVariant = 'error' | 'warning' | 'info' | 'success';

interface AlertProps {
    children: React.ReactNode;
    variant?: AlertVariant;
}

const variantStyles: Record<AlertVariant, { bg: string; border: string; text: string }> = {
    error: { bg: Colors.errorBackground, border: Colors.error, text: Colors.primary },
    warning: { bg: Colors.warningBackground, border: Colors.warning, text: Colors.primary },
    info: { bg: Colors.secondarySoft, border: Colors.secondary, text: Colors.primary },
    success: { bg: Colors.successBackground, border: Colors.success, text: Colors.primary },
};

export function Alert({ children, variant = 'warning' }: AlertProps) {
    const styles = variantStyles[variant];

    return (
        <Container style={{ backgroundColor: styles.bg, borderLeftColor: styles.border, color: styles.text }}>
            {children}
        </Container>
    );
}

const Container = styled('div')({
    padding: '10px 14px',
    borderRadius: 6,
    borderLeft: '4px solid',
    fontSize: 13,
    lineHeight: 1.4,
});
